/**
 * Schema of TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import { $, InputType, Schema } from 'simpli-web-sdk'
import { bool } from 'simpli-web-sdk'
import TipoPessoaRecebedor from '@/model/resource/TipoPessoaRecebedor'

export default (model: TipoPessoaRecebedor): Schema => ({

  idTipoPessoaPk: {
    content: model.idTipoPessoaPk,
    editable: false,
  },

  idTipoRecebedorResource: {
    textContent: model.idTipoRecebedorResource || $.t('app.notInformed'),
    input: InputType.SELECT,
    model: 'idTipoRecebedorResource',
    meta: {
      required: true,
    },
    editable: true,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  nomeAlt: {
    model: 'nome',
    content: model.nome,
    textContent: null,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },
})
